import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as actionTypes from 'web-app/react/constants/action-types';

const profileImages = handleActions(
    {
        [actionTypes.FILE_UPLOAD_FILE_PERSIST_SUCCESS]: (state, action) => {
            if (action.payload.persistedFile.large) {
                return state.set(action.payload.formName, action.payload.persistedFile.large);
            }
            return state;
        },
    },
    Map(),
);

export default profileImages;
